import type { ReactNode } from 'react'
import React from 'react'

import { Button, Icon, Loader, ModalBox, useMediaQueryContext } from '@fourthwall/components'
import { SecureBadgeIcon } from '@fourthwall/icons'

import { AddPaymentMethod } from '../AddPaymentMethod'
import * as S from './AddPaymentMethodModal.styled'

export type AddPaymentMethodModalView = {
  title: string
  subtitle?: ReactNode
  submitLabel?: string
  withChargeLimit: boolean
  onSuccess: () => void
  onClose: () => void
}

export const AddPaymentMethodModalView = ({
  title,
  subtitle,
  submitLabel,
  withChargeLimit,
  onSuccess,
  onClose,
}: AddPaymentMethodModalView) => {
  const media = useMediaQueryContext()

  const renderSubtitle = (isLoading: boolean) => {
    if (!subtitle || isLoading) {
      return null
    }

    return <S.Subtitle>{subtitle}</S.Subtitle>
  }

  return (
    <AddPaymentMethod
      submitLabel={submitLabel}
      onSuccess={onSuccess}
      withChargeLimit={withChargeLimit}
    >
      {({ renderForm, renderSubmitButton, isLoading }) => (
        <ModalBox
          title={title}
          buttons={[
            <Button label="Cancel" appearance="secondary" onClick={onClose} />,
            renderSubmitButton({ fullWidth: !media.tablet }),
          ]}
          footer={<Icon component={SecureBadgeIcon} height={20} />}
          onClose={onClose}
        >
          {isLoading && (
            <S.LoaderWrapper>
              <Loader size="large" />
            </S.LoaderWrapper>
          )}

          {renderSubtitle(isLoading)}

          {renderForm()}
        </ModalBox>
      )}
    </AddPaymentMethod>
  )
}
